// frontend-react/src/components/LogoIcon.jsx
import Box from '@mui/material/Box';
// Usa /, no \ . Ajusta la ruta si no tienes alias "@"
import logoUrl from '@/assets/images/users/logo-elvira.svg';

const sizeMap = { small: 20, medium: 24, large: 32 };

export default function LogoIconImg({ fontSize = 'large', sx, ...props }) {
  const width = typeof fontSize === 'number' ? fontSize : (sizeMap[fontSize] || 32);
  return (
    <Box
      component="img"
      src={logoUrl}
      alt="Logo Elvira"
      sx={{ width, height: 'auto', display: 'block', ...sx }}
      {...props}
    />
  );
}
